// extracted by mini-css-extract-plugin
export var active = "CommonAreas-module--active--1e80e";
export var arrow = "CommonAreas-module--arrow--28301";
export var core1 = "CommonAreas-module--core1--8b994";
export var core2 = "CommonAreas-module--core2--d342f";
export var img = "CommonAreas-module--img--afbad";
export var imgSection = "CommonAreas-module--img-section--55cca";
export var links = "CommonAreas-module--links--ec93d";
export var next = "CommonAreas-module--next--13414";
export var selector = "CommonAreas-module--selector--f4835";
export var slide = "CommonAreas-module--slide--f5053";
export var slider = "CommonAreas-module--slider--3b507";
export var text = "CommonAreas-module--text--86695";